module.exports = __webpack_public_path__ + "static/media/ios-remove.f1869ab7.svg";